export const SupervisorPlanningDashboard = [
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "attendance",
            "colorTheme": "colorTheme1",
            "title": "TODAY'S ATTENDANCE",
            "binding": {
                "data": {
                    "columns": [

                    ],
                    "title": '',
                    "endpoint": "R13",
                    "parameters": [
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {}
                    }
                }
            }
        }
    },
    {
        "columns": 6,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "coveragePerformance",
            "colorTheme": 'colorTheme1',
            "title": "TEAM COVERAGE PERFORMANCE",
            "binding": {
                "data": {
                    "endpoint": "R11",
                    "parameters": [
                        { "key": "start_date", "value": "2023-01-01" },
                        { "key": "end_date", "value": "2023-12-31" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {}
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "announcement",
            "colorTheme": 'colorTheme1',
            "title": "RECENT ANNOUNCEMENTS",
            "binding": {
                "data": {
                    "endpoint": "R12",
                    "parameters": [
                        { "key": "start_date", "value": "2023-01-01" },
                        { "key": "end_date", "value": "2023-12-31" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {}
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 3,
        "visual": {
            "id": 1,
            "type": "people",
            "colorTheme": 'colorTheme1',
            "title": "PEOPLE",
            "binding": {
                "data": {
                    "endpoint": "R14",
                    "parameters": []
                },
                "context": {
                    "point": {
                        "onClick": {}
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "bar",
            "colorTheme": 'colorTheme3',
            "title": "INCIDENTAL CALLS",
            "orientation": "vertical",
            "xAxis": "",
            "yAxis": "",
            "binding": {
                "data": {
                    "series": [
                        {
                            "name": 'Count',
                            "value": 'Value',
                            "type": 'column'

                        },
                    ],
                    "title": 'SubCycle',
                    "endpoint": "R7",
                    "parameters": [
                        { "key": "FromMonth", "value": "1" },
                        { "key": "FromYear", "value": "2025" },
                        { "key": "ToMonth", "value": "1" },
                        { "key": "ToYear", "value": "2025" },
                        { "key": "ConfigTypeCode", "value": "Y2025" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {
                            "selectedValueColumn": "CycleIndex",
                            "selectedTitle": "",
                            "visual": [
                                {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": 'colorTheme1',
                                        "title": "Incidental Call Sessions",
                                        "binding": {
                                            "data": {
                                                "columns": [
                                                    {
                                                        "name": 'Status',
                                                        "columnName": 'Status',
                                                        "width": '120px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Account Name',
                                                        "columnName": 'AccountName',
                                                        "width": '250px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Date',
                                                        "columnName": 'SessionDate',
                                                        "width": '200px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    }
                                                ],
                                                "title": "AccountName",
                                                "endpoint": "R7.1",
                                                "parameters": [
                                                    { "key": "CycleIndex", "value": "" }
                                                ]
                                            },
                                            "context": {
                                                "point": {
                                                    "onClick": {}
                                                }
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "bar",
            "colorTheme": 'colorTheme4',
            "title": "ADVANCED CALLS",
            "orientation": "vertical",
            "xAxis": "",
            "yAxis": "",
            "binding": {
                "data": {
                    "series": [
                        {
                            "name": 'Count',
                            "value": 'Value',
                            "type": 'column'

                        }
                    ],
                    "title": 'SubCycle',
                    "endpoint": "R8",
                    "parameters": [
                        { "key": "FromMonth", "value": "1" },
                        { "key": "FromYear", "value": "2025" },
                        { "key": "ToMonth", "value": "1" },
                        { "key": "ToYear", "value": "2025" },
                        { "key": "ConfigTypeCode", "value": "Y2025" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {
                            "selectedValueColumn": "CycleIndex",
                            "selectedTitle": "",
                            "visual": [
                                {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": 'colorTheme1',
                                        "title": "Advanced Call Sessions",
                                        "binding": {
                                            "data": {
                                                "columns": [
                                                    {
                                                        "name": 'Status',
                                                        "columnName": 'Status',
                                                        "width": '120px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Account Name',
                                                        "columnName": 'AccountName',
                                                        "width": '250px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Date',
                                                        "columnName": 'SessionDate',
                                                        "width": '200px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    }
                                                ],
                                                "title": "AccountName",
                                                "endpoint": "R8.1",
                                                "parameters": [
                                                    { "key": "CycleIndex", "value": "" }
                                                ]
                                            },
                                            "context": {
                                                "point": {
                                                    "onClick": {}
                                                }
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 3,
        "visual": {
            "id": 1,
            "type": "forApproval",
            "colorTheme": 'colorTheme5',
            "title": "FOR APPROVAL",
            "orientation": "vertical",
            "xAxis": "",
            "yAxis": "",
            "binding": {
                "data": {
                    "series": [
                        {
                            "name": 'Count',
                            "value": 'Value',
                            "type": 'column'

                        }
                    ],
                    "title": 'SubCycle',
                    "endpoint": "R9",
                    "parameters": [
                        { "key": "FromMonth", "value": "1" },
                        { "key": "FromYear", "value": "2025" },
                        { "key": "ToMonth", "value": "1" },
                        { "key": "ToYear", "value": "2025" },
                        { "key": "ConfigTypeCode", "value": "Y2025" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {
                            "selectedValueColumn": "CycleIndex",
                            "selectedTitle": "",
                            "visual": [
                                {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": 'colorTheme1',
                                        "title": "Recovered Call Sessions",
                                        "binding": {
                                            "data": {
                                                "columns": [
                                                    {
                                                        "name": 'Status',
                                                        "columnName": 'Status',
                                                        "width": '120px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Account Name',
                                                        "columnName": 'AccountName',
                                                        "width": '250px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Date',
                                                        "columnName": 'SessionDate',
                                                        "width": '200px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    }
                                                ],
                                                "title": "AccountName",
                                                "endpoint": "R9.1",
                                                "parameters": [
                                                    { "key": "CycleIndex", "value": "" }
                                                ]
                                            },
                                            "context": {
                                                "point": {
                                                    "onClick": {}
                                                }
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "bar",
            "colorTheme": 'colorTheme2',
            "title": "MISSED CALLS",
            "orientation": "vertical",
            "xAxis": "",
            "yAxis": "",
            "binding": {
                "data": {
                    "series": [
                        {
                            "name": 'Count',
                            "value": 'Value',
                            "type": 'column'

                        }
                    ],
                    "title": 'SubCycle',
                    "endpoint": "R6",
                    "parameters": [
                        { "key": "FromMonth", "value": "1" },
                        { "key": "FromYear", "value": "2025" },
                        { "key": "ToMonth", "value": "1" },
                        { "key": "ToYear", "value": "2025" },
                        { "key": "ConfigTypeCode", "value": "Y2025" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {
                            "selectedValueColumn": "CycleIndex",
                            "selectedTitle": "",
                            "visual": [
                                {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": 'colorTheme1',
                                        "title": "Missed Call Sessions",
                                        "binding": {
                                            "data": {
                                                "columns": [
                                                    {
                                                        "name": 'Status',
                                                        "columnName": 'Status',
                                                        "width": '120px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Account Name',
                                                        "columnName": 'AccountName',
                                                        "width": '250px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Date',
                                                        "columnName": 'SessionDate',
                                                        "width": '200px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    }
                                                ],
                                                "title": "AccountName",
                                                "endpoint": "R6.1",
                                                "parameters": [
                                                    { "key": "CycleIndex", "value": "" }
                                                ]
                                            },
                                            "context": {
                                                "point": {
                                                    "onClick": {}
                                                }
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "bar",
            "colorTheme": 'colorTheme5',
            "title": "RECOVERED CALLS",
            "orientation": "vertical",
            "xAxis": "",
            "yAxis": "",
            "binding": {
                "data": {
                    "series": [
                        {
                            "name": 'Count',
                            "value": 'Value',
                            "type": 'column'

                        }
                    ],
                    "title": 'SubCycle',
                    "endpoint": "R9",
                    "parameters": [
                        { "key": "FromMonth", "value": "1" },
                        { "key": "FromYear", "value": "2025" },
                        { "key": "ToMonth", "value": "1" },
                        { "key": "ToYear", "value": "2025" },
                        { "key": "ConfigTypeCode", "value": "Y2025" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {
                            "selectedValueColumn": "CycleIndex",
                            "selectedTitle": "",
                            "visual": [
                                {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": 'colorTheme1',
                                        "title": "Recovered Call Sessions",
                                        "binding": {
                                            "data": {
                                                "columns": [
                                                    {
                                                        "name": 'Status',
                                                        "columnName": 'Status',
                                                        "width": '120px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Account Name',
                                                        "columnName": 'AccountName',
                                                        "width": '250px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Date',
                                                        "columnName": 'SessionDate',
                                                        "width": '200px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    }
                                                ],
                                                "title": "AccountName",
                                                "endpoint": "R9.1",
                                                "parameters": [
                                                    { "key": "CycleIndex", "value": "" }
                                                ]
                                            },
                                            "context": {
                                                "point": {
                                                    "onClick": {}
                                                }
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }
    },
    {
        "columns": 6,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "summary",
            "colorTheme": 'colorTheme1',
            "title": "TEAM SALES SUMMARY",
            "binding": {
                "data": {
                    "endpoint": "R11",
                    "parameters": [
                        { "key": "start_date", "value": "2023-01-01" },
                        { "key": "end_date", "value": "2023-12-31" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {}
                    }
                }
            }
        }
    }
]